import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../contexts/LanguageContext';

const WhatsAppWidget = () => {
  const [showBubble, setShowBubble] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const phoneNumber = '77089071712';
  const { t } = useLanguage();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!dismissed) {
        setShowBubble(true);
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [dismissed]);

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShowBubble(false);
    setDismissed(true);
  };

  const openWhatsApp = () => {
    setShowBubble(false);
    setDismissed(true);
    window.open(
      `https://wa.me/${phoneNumber}?text=${encodeURIComponent(t('whatsapp.message'))}`,
      '_blank'
    );
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end">
      {/* Chat bubble */}
      {showBubble && (
        <div className="mb-3 animate-fade-in-up">
          <div className="relative bg-white rounded-2xl shadow-2xl p-4 max-w-[280px]">
            <button
              onClick={handleDismiss}
              className="absolute -top-2 -right-2 w-6 h-6 bg-gray-400 hover:bg-gray-500 text-white rounded-full flex items-center justify-center text-xs transition-colors"
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
            <p className="text-gray-800 text-sm leading-relaxed">
              {t('whatsapp.greeting')}
            </p>
            {/* Triangle pointer */}
            <div className="absolute -bottom-2 right-8 w-4 h-4 bg-white transform rotate-45 shadow-sm" />
          </div>
        </div>
      )}

      {/* WhatsApp button */}
      <button
        onClick={openWhatsApp}
        className="relative group w-16 h-16 bg-[#25D366] hover:bg-[#20bd5a] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        aria-label="WhatsApp"
      >
        {/* Notification badge */}
        {showBubble && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold animate-bounce">
            1
          </span>
        )}
        {/* WhatsApp icon */}
        <svg
          viewBox="0 0 32 32"
          fill="white"
          className="w-9 h-9"
        >
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.924 15.924 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.318 22.614c-.39 1.1-1.932 2.014-3.17 2.28-.846.18-1.95.324-5.668-1.218-4.762-1.974-7.826-6.81-8.064-7.126-.228-.316-1.926-2.566-1.926-4.892s1.218-3.47 1.652-3.944c.434-.474.948-.592 1.264-.592.316 0 .632.002.908.016.292.016.682-.11 1.066.814.39.948 1.328 3.234 1.444 3.47.118.236.196.512.04.828-.158.316-.236.512-.474.79-.236.276-.498.616-.71.826-.238.236-.486.492-.208.966.276.474 1.228 2.028 2.638 3.286 1.812 1.618 3.34 2.12 3.814 2.358.474.236.75.198 1.028-.118.276-.316 1.194-1.388 1.512-1.864.316-.474.632-.394 1.066-.236.434.158 2.718 1.282 3.184 1.516.466.236.776.354.892.55.118.196.118 1.136-.272 2.236z" />
        </svg>

        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" />
      </button>
    </div>
  );
};

export default WhatsAppWidget;
